<template>
  <div class="scratchcontainer">
    <div class="workContainer" v-for="item in scratch_data" :key="item.pk">
      <ScratchWorkItem :dic="item" :data-type="data_type" />
    </div>
  </div>
</template>

<script>
import ScratchWorkItem from "./ScratchWorkItem.vue";

import { types as WorkTypes } from "../../../store/modules/work";
import { Utils } from "@/utils";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "ScratchAllWorks",
  components: {
    ScratchWorkItem
  },
  data() {
    return {
      tag: "scratch3",
      owner: "88820190449",
      data_type: "top_scratch3"
    };
  },
  computed: {
    ...mapState({
      scratch_data: state => state.work.top_data.data,
      page: state => state.work.top_data.page,
      load_more: state => state.work.top_data.load_more,
      total_count: state => state.work.top_data.total_count
    })
  },
  methods: {
    ...mapActions({
      fetchTopWorks: WorkTypes.FETCH_LIST_MY_WORKS,
      fetchLikeWorkEvent: WorkTypes.FETCH_LIKE_EVENT
    }),
    ...Utils,

    // 点赞作品
    likeWorkEvent(item) {
      this.fetchLikeWorkEvent({ pk: item.pk, data_type: this.data_type });
    },
    //作品详情页
    jumpToWorkDetail(item) {
      let host = location.host;
      if (location.host.indexOf("develop.cxy61.com") > -1) {
        host = "app.bcjiaoyu.com";
      }
      window.open(
        `https://${host}/html/works/works_detail.html?pk=${item.pk}`,
        "_blank"
      );
    },
    handleScroll(e) {
      let page = this.page;
      let load_more = this.load_more;

      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (scrollHeight <= height + scrollTop + 20) {
        if (load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
          that.fetchTopWorks({
            page: page + 1,
            page_size: 10,
            work_type: this.tag,
            data_type: this.data_type,
            owner: this.owner
          });
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    }
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    let dic = {
      page: 1,
      page_size: 10,
      work_type: this.tag,
      data_type: this.data_type,
      owner: this.owner
    };
    this.fetchTopWorks(dic);
  }
};
</script>

<style lang="less" scoped>
.scratchcontainer {
  background-color: #fff;
  display: flex;
  border-radius: 8px;
  flex-direction: row;
  flex-wrap: wrap;
  width: calc(100%);
  margin: auto;
  padding: 15px;
  box-sizing: border-box;
  .workContainer {
    background-color: #ffffff;
    border: solid 1px #ebebeb;
    margin: 5px;
    margin-bottom: 10px;
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    width: calc(100% / 4 - 12px);
    position: relative;
  }
}
</style>